// src/shared/constants.js
export const CATEGORY_ICON = {
    sport_archery: '🏹',
    sport_horse: '🐎',
    sport_ski: '⛷️',
    sport_paragliding: '🪂',
    sport_climbing: '🧗',
    adventure_park: '🎢',
    suspension_bridge: '🌉',
    alpine_hut: '🏠',
    bivouac: '⛺',
    shelter: '🏕️',
    peak: '🏔️',
    lake: '🏞️',
    waterfall: '💦',
    spring: '💧',
    cave: '🕳️',
    parking: '🅿️',
    viewpoint: '📷',
    church: '⛪',
    ruins: '🏛️',
    generic: '📍'
};

/**
 * Campi dinamici per i filtri.
 * `labelKey` è la chiave i18n da usare con t(field.labelKey).
 * `type` rimane invariato per la logica dei filtri.
 */
export const dynamicFields = {
    lengthCategory:        { labelKey: 'filter_lengthCategory',        type: 'category' },
    ascentCategory:        { labelKey: 'filter_ascentCategory',        type: 'category' },
    elevationRangeCategory:{ labelKey: 'filter_elevationRangeCategory',type: 'category' },
    totalDurationCategory: { labelKey: 'filter_totalDurationCategory', type: 'category' },
    forest:                { labelKey: 'filter_forest',                type: 'boolean'  },
    coastal:               { labelKey: 'filter_coastal',               type: 'boolean'  },
    difficulty:            { labelKey: 'filter_difficulty',            type: 'text'     },
    surface:               { labelKey: 'filter_surface',               type: 'text'     },
    widthCategory:         { labelKey: 'filter_widthCategory',         type: 'category' },
    scenic:                { labelKey: 'filter_scenic',                type: 'category' },
    lake:                  { labelKey: 'filter_lake',                  type: 'category' },
    waterfall:             { labelKey: 'filter_waterfall',             type: 'category' },
    river:                 { labelKey: 'filter_river',                 type: 'category' },
    wheelchair:            { labelKey: 'filter_wheelchair',            type: 'category' },
    mtbCompatible:         { labelKey: 'filter_mtbCompatible',         type: 'category' },
    mtbScaleGrade:         { labelKey: 'filter_mtbScaleGrade',         type: 'category' },
    horseCompatible:       { labelKey: 'filter_horseCompatible',       type: 'category' },
    viaFerrata:            { labelKey: 'filter_viaFerrata',            type: 'category' },
    viaFerrataGrade:       { labelKey: 'filter_viaFerrataGrade',       type: 'category' },
};

/**
 * Helper da usare nei componenti React:
 *   import { getFilterLabel } from '../shared/constants.js';
 *   const { t } = useTranslation();
 *   getFilterLabel('lengthCategory', t)  →  "Trail Length" / "Lunghezza percorso"
 */
export function getFilterLabel(fieldKey, t) {
    const field = dynamicFields[fieldKey];
    if (!field) return fieldKey;
    return t(field.labelKey, fieldKey); // fallback = chiave grezza
}

/**
 * Ordine di visualizzazione dei filtri nella GUI
 */
export const filterOrder = [
    'lengthCategory',
    'forest',
    'coastal',
    'ascentCategory',
    'elevationRangeCategory',
    'totalDurationCategory',
    'caiScale',
    'difficulty',
    'surface',
    'widthCategory'
];

/**
 * Chiave i18n per i valori mancanti — usa t('filter_none_label') nei componenti
 */
export const NONE_LABEL_KEY = 'filter_none_label';
